/* eslint-disable no-unused-vars */

import { throttle } from 'lodash'
class Scroller {
  /**
   * 给tableBody创建一个scroller
   * @param {Element} targetTableWrapperEl
   * @param {string} mode
   */
  constructor(targetTableWrapperEl, mode = 'hover') {
    if (!targetTableWrapperEl) {
      throw new Error('need have table element')
    }
    this.targetTableWrapperEl = targetTableWrapperEl
    this.fullwidth = false
    this.mode = mode

    /**
     * 创建相关dom
     */
    const scroller = document.createElement('div')
    scroller.classList.add('el-scrollbar')
    scroller.style.height = '20px'
    scroller.style.position = 'fixed'
    // scroller.style.background = '#f1f1f1'

    scroller.style.bottom = 0
    scroller.style.zIndex = 3

    this.dom = scroller
    this.resetScroller()

    const bar = document.createElement('div')
    bar.style.height = '15px'
    bar.classList.add('el-scrollbar__bar', 'is-horizontal')
    this.bar = bar
    scroller.appendChild(bar)

    const thumb = document.createElement('div')
    // border-radius
    thumb.style.borderRadius = '0'
    thumb.style.background = '#c1c1c1'
    thumb.classList.add('el-scrollbar__thumb')
    bar.appendChild(thumb)
    this.thumb = thumb

    /**
     * 初始化配置
     */
    const instance = this
    this.checkIsScrollBottom = throttle(function() {
      const viewHeight = window.innerHeight || document.documentElement.clientHeight
      const { bottom } = targetTableWrapperEl.getBoundingClientRect()
      if (bottom <= viewHeight) {
        instance.hideScroller()
      } else {
        // 需要重新设置一次当前宽度
        instance.resetBar(false)
        // 显示当前的bar
        instance.showScroller()
      }
    }, 1000 / 60)

    document.addEventListener('scroll', this.checkIsScrollBottom) // 全局判断是否需要显示scroller

    // 自动同步,table => scroller
    targetTableWrapperEl.addEventListener('scroll', throttle(function() {
      instance.resetThumbPosition()
    }, 1000 / 60))

    // 自动同步 scroller => table
    this.syncDestoryHandler = this.initScrollSyncHandler()

    // 监听变化
    this.tableElObserver = throttle(() => {
      this.resetBar()
      this.resetScroller()
      this.resetThumbPosition()
      this.checkIsScrollBottom()
    }, 300)

    // 监听侧边栏的变化
    window.addEventListener('resize', this.tableElObserver)
    const sidebarElm = document.getElementsByClassName('sidebar-container')[0]
    sidebarElm.addEventListener('transitionend', this.tableElObserver)

    // 监听页面竖向滚动,快到底部的时候隐藏
    this.onPageYScroll = (e) => {
      const scrollTop = e.target.scrollTop
      const windowHeitht = e.target.clientHeight
      const scrollHeight = e.target.scrollHeight
      const total = scrollTop + windowHeitht + 80

      const { targetTableWrapperEl } = this
      const widthPercentage = (targetTableWrapperEl.clientWidth * 100 / targetTableWrapperEl.scrollWidth)
      const thumbWidth = Math.min(widthPercentage, 100)
      this.thumb.style.width = `${thumbWidth}%`

      this.fullwidth = thumbWidth >= 100

      if (total >= scrollHeight || this.fullwidth) {
        this.dom.style.display = 'none'
      } else {
        this.dom.style.display = 'initial'
      }
    }
    document.getElementsByClassName('layout-scrollbar-wrapper')[0].addEventListener('scroll', this.onPageYScroll)

    // bar宽度自动重制
    setTimeout(() => {
      this.resetBar()
      this.resetScroller()
      this.resetThumbPosition()
      this.checkIsScrollBottom()
    }, 500)
  }

  /**
   * 自动设置Bar
   * @param {boolean} changeScrollerVisible 是否开启自动设置滚动条显示与否
   */
  resetBar(changeScrollerVisible = true) {
    const { targetTableWrapperEl } = this
    const widthPercentage = (targetTableWrapperEl.clientWidth * 100 / targetTableWrapperEl.scrollWidth)
    const thumbWidth = Math.min(widthPercentage, 100)
    this.thumb.style.width = `${thumbWidth}%`

    this.fullwidth = thumbWidth >= 100

    if (changeScrollerVisible) {
      if (this.fullwidth) {
        this.hideScroller()
      } else {
        this.checkIsScrollBottom()
      }
    }
  }

  resetThumbPosition() {
    this.thumb.style.transform = `translateX(${this.moveX}%)`
  }

  resetScroller() {
    const { targetTableWrapperEl, dom } = this
    const boundingClientRect = targetTableWrapperEl.getBoundingClientRect()
    dom.style.left = boundingClientRect.left + 'px'
    dom.style.width = boundingClientRect.width + 'px'
  }

  get moveX() {
    const { targetTableWrapperEl } = this
    return ((targetTableWrapperEl.scrollLeft * 100) / targetTableWrapperEl.clientWidth)
  }

  /**
   * 让scroller的拖动行为和table的同步
   * 处理类似element-ui的拖拽处理
   */
  initScrollSyncHandler() {
    let cursorDown = false
    let tempClientX = 0
    let rate = 1

    const { thumb, targetTableWrapperEl, bar } = this

    function getRate() {
      // 计算一下变换比例，拖拽走的是具体数字，但是这个实际上应该是按照比例变的
      return bar.offsetWidth / thumb.offsetWidth
    }

    const mouseMoveDocumentHandler = throttle(
      /** @param {MouseEvent} e */
      function(e) {
        if (cursorDown === false) {
          return
        }
        const { clientX } = e
        const offset = clientX - tempClientX
        const originTempClientX = tempClientX
        tempClientX = clientX

        const tempScrollleft = targetTableWrapperEl.scrollLeft
        targetTableWrapperEl.scrollLeft += offset * rate
        if (tempScrollleft === targetTableWrapperEl.scrollLeft) {
          tempClientX = originTempClientX
        }
      }, 1000 / 60)
    /** @param {MouseEvent} e */
    function mouseUpDocumentHandler() {
      cursorDown = false
      document.removeEventListener('mousemove', mouseMoveDocumentHandler)
      document.removeEventListener('mouseup', mouseUpDocumentHandler)
      document.onselectstart = null
    }

    /**
     * 拖拽处理
     * @param {MouseEvent} e
     */
    function startDrag(e) {
      e.stopImmediatePropagation()
      cursorDown = true
      document.addEventListener('mousemove', mouseMoveDocumentHandler)
      document.addEventListener('mouseup', mouseUpDocumentHandler)
      document.onselectstart = () => false
    }

    thumb.onmousedown = function(e) {
      // prevent click event of right button
      if (e.ctrlKey || e.button === 2) {
        return
      }

      const { clientX } = e
      tempClientX = clientX
      rate = getRate()
      startDrag(e)
    }

    /**
     * 点击槽快速移动
     * @param {PointerEvent} e
     */
    bar.onclick = function(e) {
      const { target } = e
      if (target !== bar) {
        return
      }
      rate = getRate()
      const { clientX } = e
      let offset = 0
      const thumbPosition = thumb.getBoundingClientRect()
      if (thumbPosition.left >= clientX) {
        offset = (clientX - thumbPosition.left)
      } else {
        offset = clientX - thumbPosition.left - thumbPosition.width
      }

      const targetScrollLeft = targetTableWrapperEl.scrollLeft + offset * rate
      targetTableWrapperEl.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      })
    }

    return function() {
      document.removeEventListener('mouseup', mouseUpDocumentHandler)
    }
  }

  /**
   * 显示整体
   */
  showScroller() {
    if (!this.fullwidth) {
      this.dom.style.display = 'initial'
    }
  }

  /**
   * 隐藏整体
   */
  hideScroller() {
    if (this.mode === 'force') {
      this.mode.style.display = 'initial'
    } else {
      this.dom.style.display = 'none'
    }
  }

  /**
   * 显示滚动条
   */
  showBar() {
    this.bar.style.opacity = 1
  }

  /**
   * 隐藏滚动条
   */
  hideBar() {
    // if (this.mode === 'force') {
    //   this.bar.style.opacity = 1
    // } else {
    //   this.bar.style.opacity = 0
    // }
  }

  destory() {
    window.removeEventListener('resize', this.tableElObserver)

    const sidebarElm = document.getElementsByClassName('sidebar-container')[0]
    if (sidebarElm) {
      sidebarElm.removeEventListener('transitionend', this.tableElObserver)
    }
    document.removeEventListener('scroll', this.checkIsScrollBottom)
    this.syncDestoryHandler()
  }
}

/** @type {Vue.DirectiveOptions} */
export const directiveVue2 = {
  inserted(el, binding) {
    const { value = 'hover' } = binding
    const tableBodyWrapper = el.querySelector('.el-table__body-wrapper')
    const scroller = new Scroller(tableBodyWrapper, value)

    el.appendChild(scroller.dom)
    el.horizontalScroll = scroller

    // if (value === 'hover') {
    //   el.addEventListener('mouseover', scroller.showBar.bind(scroller))
    //   el.addEventListener('mouseleave', scroller.hideBar.bind(scroller))
    // } else {
    // }
    scroller.showBar()
  },
  unbind(el) {
    el.horizontalScroll.destory()
  }
}

/**
 * 插件
 * @type {VuePlugin}
 */
export const Plugin = {
  install(Vue) {
    Vue.directive('horizontalScroll', {
      ...directiveVue2
    })
  }
}

export default Plugin
